// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useEffect, useRef, useState} from 'react';
import {get_height, get_width} from './screen_util';

type t_part = 'top'|'bottom';
interface i_options {
    treshold?: number;
    max_width?: number;
    duration?: number;
    translate?: number;
    part?: t_part;
    treshold_abs?: number;
    logic_disabled?: boolean;
    selector?: string;
    delay?: number;
}
export const use_section_scroll = (r, show?, options:i_options = {})=>{
    const {treshold = 0.6, max_width = 992, duration = 700,
        translate = 150, part = 'bottom', treshold_abs, selector,
        delay = 0} = options;
    const [scrolled, set_scrolled] = useState(false);
    const top = useRef();
    useEffect(()=>{
        if (options.logic_disabled)
            return;
        if (scrolled || get_width() < max_width)
            return;
        if (!show && r.current)
        {
            r.current.style.transition =
                `transform ${duration}ms ease ${delay}ms, `
                +`opacity ${duration}ms ease ${delay}ms`;
            r.current.style.opacity = 0;
            r.current.style.transform = `translateY(${translate}px)`;
        }
        let first_handle;
        const handle_scroll = ()=>{
            clearTimeout(first_handle);
            if (selector)
                top.current = r.current.closest(selector);
            else if (!top.current && r.current)
            {
                top.current = r.current.previousSibling ||
                    (r.current.closest('.container')||{}).previousSibling ||
                    (r.current.closest('section')||{}).previousSibling;
            }
            // @ts-ignore
            if (top.current && top.current.getBoundingClientRect()[part] <
                (treshold_abs || get_height()*treshold) && r.current)
            {
                r.current.classList.add('scrolled');
                r.current.style.opacity = 1;
                r.current.style.transform = 'none';
                set_scrolled(true);
            }
        };
        window.addEventListener('scroll', handle_scroll, {passive: true});
        first_handle = setTimeout(()=>handle_scroll(), 2000);
        return ()=>{
            window.removeEventListener('scroll', handle_scroll);
            clearTimeout(first_handle);
        };
    }, [scrolled]);
    return scrolled;
};
